import React, { useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { OUTCOMES } from "../../../constants";
import { FlowScreenWrapper } from "./FlowScreenWrapper";
import { useAuthContext } from "../../../AuthContextWrapper";
import { SingleAddressForm } from "./SingleAddressForm";
// import { AtticusMySQL } from "../../../apis/AtticusMySQL";

interface Props {
  title?: string;
  screenData?: any;
}

export const AddressScreen = ({ title }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const { flow } = useAuthContext()
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  // const userProfile = screenData?.length && screenData[0];
  // const address = (userProfile?.address_one as string) || "";

  const handleComplete = async (): // address?: string,
  // countryId?: number,
  // stateId?: number
  Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    // if (
    //   !(await flow?.saveData(currentScreen, "me", {
    //     full_address: address,
    //   }))
    // ) {
    //   throw new Error("could not save data");
    // }

    flow?.navigateToNext(currentScreen, OUTCOMES.complete, navigate);
    return true;
  };

  // const handleClear = async (): Promise<void> => {
  //   console.log("handleClear");
  // };

  return currentScreen ? (
    <FlowScreenWrapper title={title || "What is your address?"}>
      <SingleAddressForm
        // TODO: implement initPlace
        // initAddress={address}
        onComplete={handleComplete}
        // onClear={handleClear}
        onBack={() => navigate(-1)}
      />
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
